import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './PDFViewerModal.css';

const PDFViewerModal = ({ isOpen, onClose, pdfUrl, title, showDownload = true }) => {
  const { t } = useTranslation();
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleDownload = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal-header">
          <h3 className="pdf-modal-title">{title || t('homework.pdfViewer')}</h3>
          <div className="pdf-modal-actions">
            {showDownload && (
              <button className="pdf-modal-download" onClick={handleDownload}>
                Download
              </button>
            )}
            <button className="pdf-modal-close" onClick={onClose}>
              &times;
            </button>
          </div>
        </div>
        <div className="pdf-modal-body pdf-scrollable">
          <iframe
            ref={iframeRef}
            src={pdfUrl}
            className="pdf-iframe"
            title={title || 'PDF Viewer'}
          />
          <div className="pdf-modal-fallback">
            <p>Kan de brochure niet embedded tonen? Open hem in een nieuw tabblad.</p>
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer">Open brochure</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFViewerModal;

